<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("traffic.alarm") }}</label>
        <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="activeFilter" class="w-100"
          :reduce="(val) => val.value" :options="[
            { label: 'true', value: 1 },
            { label: 'false', value: 0 },
          ]" @input="(val) => $emit('update:activeFilter', val)" append-to-body :calculate-position="withPopper" />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("traffic.counter") }}</label>
        <v-select :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :value="counterFilter" class="w-100"
          :reduce="(val) => val.value" :options="[
            { label: $t('traffic.with_counter'), value: 1 },
            { label: $t('traffic.without_counter'), value: 0 },
          ]" @input="(val) => $emit('update:counterFilter', val)" append-to-body :calculate-position="withPopper" />
      </b-col>

    </b-row>
    <b-row>
      <b-col cols="6" class="mb-0">
        <label class="text-capitalize">{{ $t("log_microservice.start_date") }}</label>
        <div class="input-group">
          <flat-pickr :value="startDate" class="form-control" @input="(val) => dateStarClick(val)"
            :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            :style="dateStartRequired ? 'border: solid red 1px' : ''" />
          <div class="input-group-append">
            <button @click="handleClick()" class="btn btn-outline-primary" type="button">
              x
            </button>
          </div>
        </div>
        <div class="errorText" v-show="dateStartRequired">
          {{
            $t("log_microservice.The_start_date_value_is_required_for_filter_by_date")
          }}
        </div>
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t("log_microservice.end_date") }}</label>
        <div class="input-group">
          <flat-pickr :value="endDate" class="form-control" @input="(val) => dateEndClick(val)"
            :config="{ maxDate: new Date(), enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true, minuteIncrement: 1 }"
            :style="dateEndRequired ? 'border: solid red 1px' : ''" />
          <div class="input-group-append">
            <button @click="handleClick()" class="btn btn-outline-primary" type="button">
              x
            </button>
          </div>
        </div>
        <div class="errorText" v-show="dateEndRequired">
          {{ $t("log_microservice.The_end_date_value_is_required_to_filter_by_date") }}
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { integer } from "@/@core/utils/validations/validations";
import popperHelper from "@/libs/popper-helper";
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormCheckbox,
    vSelect,
    flatPickr
  },
  props: {
    activeFilter: {
      type: integer,
      default: null,
    },
    counterFilter:{
      type: integer,
      default: null,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      dateStartRequired: false,
      dateEndRequired: false,
      dateStartComponent: null,
      dateEndComponent: null,
    };
  },
  methods: {
    verification() {
      const start = this.dateStartComponent ?? this.startDate;
      const end = this.dateEndComponent ?? this.endDate;

      this.dateStartRequired = !start;
      this.dateEndRequired = !end;

      if (start && end) {
        this.$emit('update:startDate', this.dateStartComponent || this.startDate);
        this.$emit('update:endDate', this.dateEndComponent || this.endDate);
      }
    },

    handleClick() {
      this.$emit('update:startDate', null);
      this.dateStartRequired = false;
      this.dateStartComponent = null
      this.$emit('update:endDate', null);
      this.dateEndRequired = false;
      this.dateEndComponent = null
    },

    dateStarClick(val) {
      if (val !== "") {
        this.dateStartComponent = val
        this.verification()
      }
    },
    dateEndClick(val) {
      if (val !== "") {
        this.dateEndComponent = val
        this.verification()
      }
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.pagination {
  display: flex;
  justify-content: space-around;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;

  &:first-child {
    margin-right: 5px;
  }
}

.pagination button:hover {
  cursor: pointer;
}

.errorInput {
  border: solid red 1px
}

.errorText {
  color: red;
  font-size: 12px
}
</style>
